/** @module components/signup-overlay */
import baustein from "baustein";
import { closeSignupOverlay } from "web/redux/ducks/signup-overlay";
import store from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import overlayMixin from "web/script/components/mixins/overlay-mixin";
import LoginOverlay from "web/script/components/overlays/login-overlay";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import requester from "web/script/modules/requester";
import history from "web/script/utils/history";

/**
 * Handles functionality of the new sign up overlay
 *
 * @constructor
 * @alias module:components/signup-overlay
 * @extends module:baustein
 */
export default baustein.register(
    "signup-overlay",
    /** @lends module:components/signup-overlay.prototype */
    {
        mixins: [overlayMixin],

        defaultOptions: {
            isOverlay: false,
            overlaySize: "width-750",
            noContentPadding: true,
            queryParams: {},
            // todo I18N-161
            path: "/account/register/",
            formType: "unknown",
            loginSuccessRedirectUrl:
                window && window.location && window.location.pathname + window.location.search,
        },

        setupEvents(add) {
            add("userSuccessfullyRegistered", this.userSuccessfullyRegistered);
            add("click", ".login-link", this.switchToLogin);
        },

        onOverlayCloseIntent() {
            if (this.options.isOverlay) {
                const eventCategory = this._getEventCategory();
                analytics.event(eventCategory, "close_signup_form", "exit_signup");
                history.back();
                this.close();
                store.dispatch(closeSignupOverlay());
            }
        },

        onOverlayOpen() {
            if (this.options.isOverlay) {
                this.trackPageView();
            }
        },

        getOverlayContent() {
            return requester(this.options.path, {
                headers: {
                    Accept: "text/html",
                },
                query: this.options.queryParams,
            }).then((resp) => {
                // If we get back application/json then the user is
                // already logged in. Perhaps a further improvement -
                // we detect this when the save for later button is
                // clicked and redirect + save for later at the same
                // time
                if (
                    resp.status === 200 &&
                    resp.headers.get("content-type") === "application/json"
                ) {
                    analytics.tagEvent(
                        analytics.TAG_NETWORKS.FACEBOOK,
                        facebookEvents.REGISTRATION_COMPLETE
                    );
                    globals.window.location = this.options.loginSuccessRedirectUrl;
                    return;
                } else {
                    return requester.toText(resp);
                }
            });
        },

        trackPageView() {
            analytics.pageView();
        },

        switchToLogin(event) {
            if (event) {
                event.preventDefault();
            }
            this.close();
            const eventCategory = this._getEventCategory();
            analytics.event(eventCategory, "toggle", "sign_in");
            const pageType = "signin_form";
            const pageSubType = eventCategory.replace("signup", "signin");
            environment.set({
                pageType,
                pageSubType,
            });
            const overlay = new LoginOverlay({
                queryParams: this.options.queryParams,
            });
            overlay.appendTo(document.body);
            overlay.open();
        },

        _getEventCategory() {
            const newSignupFormComponent = this.findComponent("signup-form");
            if (newSignupFormComponent) {
                return newSignupFormComponent.options.eventCategory;
            }
            // back in stock email capture doesn't have a "signup-form" component
            return "back_in_stock";
        },
    }
);
